const FILTERS = {
    eoslForm: {
        product_id: {
            title: 'Products',
            iconClass: 'sitemap'
        }
    }
}
export default FILTERS;